// extracted by mini-css-extract-plugin
module.exports = {"TwoDimsFeature":"wo_a bht_b bht_ux"};